import {useSelector} from "react-redux";
import React from "react";
import saly from "../images/saly.jpg";

export const Support = () => {
    const lang = useSelector(state => state.app.currentLang)
    return (
        <div className="supportPage">
            <div className="supportPage__heading"><span>{lang.message2}</span></div>
            <div className="supportPage__message" dangerouslySetInnerHTML={{__html: lang.message3}}/>
            <div className="supportPage__img" style={{backgroundImage: 'url(' + saly + ')'}}></div>
        </div>

    )
}